import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ReactGA from "react-ga4";

import "./App.css";
import VerifyAccount from "./webpages/verify-account";
import Dashboard from "./webpages/dashboard";
import LoginPage from "./webpages/loginPage";
import MyProfile from "./webpages/myProfile/myProfile";
import MyCourses from "./webpages/myProfile/mycourses";
import PersonalInfo from "./webpages/myProfile/personalInfo";
import Support from "./webpages/support";
import Student from "./webpages/student";
import TutorRegister from "./tutor-register";
import WaLogin from "./webpages/waLogin";
import Faqs from "./webpages/faq";
import Franchise from "./webpages/franchiseForm";
import Counselling from "./webpages/counselling";
import AppliedTutors from "./webpages/appliedTutors";
import TutorInterest from "./webpages/tutorInterest";
import DynamicNavigate from "./webpages/dynamicNavigate";
import NewAddress from "./webpages/myProfile/newAddressPage";
import Header from "./components/Header";
import MyReports from "./webpages/myProfile/MyReports";
import AppliedClassesComponent from "./webpages/myProfile/AppliedClasses/AppliedClassesComponent";
import BankDetails from "./webpages/myProfile/BankDetails";
import SubscriptionComponent from "./webpages/myProfile/Subscription/SubscriptionComponent";
import Footer from "./components/Footer/Footer";
import PaymentSuccess from "./webpages/payment-success";
import PaymentFailure from "./webpages/payment-failure";
import VerifyAccountLogin from "./webpages/verify-account-login";
import Attendance from "./webpages/myProfile/Attendance";
import TutorTermsGate from "./components/TutorTermsGate/TutorTermsGate";

function App() {
  ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);

  return (
    <div>
      <Router>
        <TutorTermsGate />
        <Header></Header>

        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/wa-login/:randomString" element={<WaLogin />} />
          <Route path="/register" element={<TutorRegister />} />
          <Route path="/tutor-applied/:dealId" element={<AppliedTutors />} />
          <Route path="/tutor-interest/:dealId" element={<TutorInterest />} />
          <Route path="/counselling" element={<Counselling />} />
          <Route path="/own-a-franchise" element={<Franchise />} />
          <Route path="/student" element={<Student />} />
          <Route path="/verify-account" element={<VerifyAccount />} />
          <Route path="/verify-account-login" element={<VerifyAccountLogin />} />
          <Route path="/update/address-and-course" element={<DynamicNavigate />} />

          <Route path="/my-profile" element={<MyProfile />} />
          {/* menu item pages */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/personal-info" element={<PersonalInfo />} />
          <Route path="/my-courses" element={<MyCourses />} />
          <Route path="/address" element={<NewAddress />} />
          <Route path="/my-reports" element={<div className="tutor-page-container"><MyReports /></div>} />
          <Route path="/attendance" element={<Attendance />} />
          <Route path="/applied-classes" element={<AppliedClassesComponent />} />
          <Route path="/bank-details" element={<BankDetails />} />
          <Route path="/subscription" element={<SubscriptionComponent />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/support" element={<Support />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failure" element={<PaymentFailure />} />
        </Routes>
      </Router>

      <Footer />
    </div>
  );
}

export default App;
